/* eslint-disable */
import errorHandlerService from '../Service/errorHandler'
import CheckInDateRangeObjectValue from '../ObjectValue/CheckInDateRange'
import moment from "moment";
import 'moment/locale/ru';

let maxDifference = 30*3600*24*1000,
	tomorrow = new Date();

	tomorrow.setHours(0);
	tomorrow.setMinutes(0);
	tomorrow.setSeconds(0);
	tomorrow.setMilliseconds(0);
	tomorrow.setDate(tomorrow.getDate() + 1);

const CheckInDateRangeFactory = function(data, defaultData, options) {
	var checkInDateRange = {},
		tmpDate,
		getDate,
		element;

	defaultData = typeof (defaultData) != "undefined" ? defaultData : {from:tomorrow, to:moment(tomorrow).add(7, 'day')._d};

	try {
		getDate = function(date, dateDifference) {
			var outDate = null,
				dateParts,
				currentDate = new Date();

			if(date instanceof Date) {
				outDate = date;
			} else {
				if(date.length > 10) {
					date = date.substr(0,10);
				}
				if(date == parseInt(date, 10)) {
					outDate = new Date(currentDate.getTime() + date*3600*24*1000);
				} else if(date.indexOf('.') != -1 && date.length == 10) {
					dateParts = date.split('.');
					outDate = new Date(dateParts[2], dateParts[1]-1, dateParts[0]);
				} else if(date.indexOf('-') != -1 && date.length == 10) {
					dateParts = date.split('-');
					outDate = new Date(dateParts[0], dateParts[1]-1, dateParts[2]);
				}
			}

			if(dateDifference && outDate !== null) {
				outDate = new Date(outDate.getTime() + dateDifference*3600*24*1000);
			}
			return outDate;
		};

		if(data['from'] instanceof Date && data['to'] instanceof Date) {
			checkInDateRange = {
				from:data['from'],
				to:data['to']
			};
		} else if(data['from'] && data['daysFlexible']) {
			checkInDateRange['from'] = getDate(data['from'], -data['daysFlexible']);
			checkInDateRange['to'] = getDate(data['from'], +data['daysFlexible']);
		} else {
			element = data['to'];
			if(typeof element != "undefined") {
				checkInDateRange['to'] = getDate(element);
			} else if(typeof data['from'] != "undefined") {
				checkInDateRange['to'] = getDate(data['from']);
			}

			element = data['from'];
			if(typeof element != "undefined") {
				checkInDateRange['from'] = getDate(element);
			}
		}

		if(checkInDateRange['from'] !== null && !isNaN(checkInDateRange['from'].getTime()) && checkInDateRange['to'] !== null && !isNaN(checkInDateRange['to'].getTime())) {
			if(checkInDateRange['from'] > checkInDateRange['to']) {
				tmpDate = checkInDateRange['from'];
				checkInDateRange['from'] = checkInDateRange['to'];
				checkInDateRange['to'] = tmpDate;
			}

			if(!(options && options.disableOldDateCorrection)) {
				if (checkInDateRange['from'] < tomorrow && checkInDateRange['to'] < tomorrow) {
					checkInDateRange['from'] = getDate(defaultData['from']);
					checkInDateRange['to'] = getDate(defaultData['to']);
				} else {
					if (checkInDateRange['from'] < tomorrow) {
						checkInDateRange['from'] = tomorrow;
					}
				}
			}

			if(checkInDateRange['to'].getTime() - checkInDateRange['from'].getTime() > maxDifference) {
				errorHandlerService('Date from: ' + checkInDateRange['from'] + ' and dateTo: ' + checkInDateRange['to'] + ' has more than ' + maxDifference/3600/1000/24 + ' days of difference!');
				checkInDateRange['to'] = new Date(checkInDateRange['from'].getTime() + maxDifference);
			}

			return new CheckInDateRangeObjectValue(checkInDateRange);
		} else {
			return null;
		}
	}
	catch(error) {
		errorHandlerService("JS Error!", error);
	}
};

export default CheckInDateRangeFactory;
